// File: src/components/home/Hero.js

import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Hero.module.css';
import { cn } from '../../utils/helpers';
import { ASSETS_BASE_URL } from '../../config/constants';

const HERO_VIDEO_URL = `${ASSETS_BASE_URL}/hero-video-organic-waste-light.mov`;

function Hero() {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.bottom > 0) {
          setScrollY(window.scrollY);
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const playVideo = () => {
      video.play().catch(() => {});
    };

    if (video.readyState >= 3) {
      playVideo();
    } else {
      video.addEventListener('loadeddata', playVideo);
    }

    return () => {
      video.removeEventListener('loadeddata', playVideo);
    };
  }, []);

  return (
    <section className={styles.hero} ref={sectionRef}>
      <div className={styles.card}>

        {/* ── Parallax video layer ── */}
        <div
          className={styles.videoBg}
          style={{ transform: `translateY(${scrollY * 0.25}px)` }}
        >
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            className={styles.video}
            preload="auto"
          >
            <source src={HERO_VIDEO_URL} type="video/mp4" />
          </video>
          <div className={styles.overlay} />
        </div>

        {/* ── All content inside the card ── */}
        <div className={styles.content}>
          <div className={styles.titleBlock}>
            <h1 className={styles.title}>
              <span className={styles.line}>
                <span className={styles.word}>TRANSFORMING</span>
              </span>
              <span className={styles.line}>
                <span className={cn(styles.word, styles.wordGreen)}>WASTE</span>
                <span className={styles.word}>&nbsp;INTO</span>
              </span>
              <span className={styles.line}>
                <span className={cn(styles.word, styles.wordOutline)}>SUSTAINABLE</span>
              </span>
              <span className={styles.line}>
                <span className={cn(styles.word, styles.wordGreen)}>FUTURES</span>
              </span>
            </h1>
          </div>

          <div className={styles.bottom}>
            <p className={styles.subtitle}>
              Pioneering patented technology that diverts organic waste from landfills
            </p>
            <Link to="/solution" className={styles.cta}>
              <span>Explore How It Works</span>
              <span className={styles.ctaArrow}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path
                    d="M4 10h12m0 0l-4-4m4 4l-4 4"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}

export default Hero;